import styles from './ErrorMessage.module.css';

function ErrorMessage() {
  return <p className={styles.text}>There was an error, please try again...</p>;
}

export default ErrorMessage;
